export default
{
    palette: {
      primary: {
        light: '#757ce9',
        main: '#3f50b5',
        dark: '#002884',
        contrastText: '#fff',
      },
      secondary: {
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
        contrastText: '#000',
      },
      
    },
    typography:{
      useNextVariants:true
    },
  spreadThis:{
  form:{
      textAlign:'center'
  },
  image:{
      margin:'20px auto 20px auto',
      height:'60px'
  },
  pageTitle:{
      margin:'10px auto 10px auto'
  },
  textField:{
      margin:'10px auto 10px auto'
  },
  button:{
      marginTop:20,
      position:'relative',
      
  },
  customError:{
      color:'red',
      fontSize: '0.8rem',
      marginTop:10
  },
  progress:{
      position:'absolute'
  
  },
  invisibleSeparator:{
    border:'none',
    margin: 4
},
visibleSeparator:{
  width:'100%',
  borderBottom: '1px solid rgba(0,0,0,0.1)',
  marginBottom:'20'

}
  
  }
  }